import { debounce } from 'lodash';
import { mapActions } from 'vuex';

export default {
  props: {
    domain: {
      type: String,
      required: true,
    },
    itemText: {
      type: String,
      default: 'translatedName',
    },
    label: {
      type: String,
      required: false,
      default: 'Eintrag auswählen',
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: [String, Array],
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      search: '',
      items: [],
    };
  },
  watch: {
    search() {
      if (this.searchable) {
        this.debouncedSearch();
      }
    },
  },
  mounted() {
    this.debouncedSearch = debounce(this.fetchData, 300);
    if (!this.searchable) {
      this.fetchData();
    }
  },
  methods: {
    ...mapActions('app', ['fetchLookupData']),
    fetchData() {
      this.isLoading = true;

      return this.fetchLookupData({
        domainName: this.domain,
        search: this.search,
      })
        .then(({ data }) => {
          this.items = data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
